"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useLatest_1 = __importDefault(require("./useLatest"));
function useDelayed(callback, delayMs) {
    const callbackRef = (0, useLatest_1.default)(callback);
    (0, react_1.useEffect)(() => {
        const timeoutId = setTimeout(() => {
            callbackRef.current();
        }, delayMs);
        return () => {
            clearInterval(timeoutId);
        };
    });
}
exports.default = useDelayed;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlRGVsYXllZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvaG9va3MvdXNlRGVsYXllZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLGlDQUFrQztBQUNsQyw0REFBb0M7QUFJcEMsU0FBd0IsVUFBVSxDQUNoQyxRQUE0QixFQUM1QixPQUFlO0lBRWYsTUFBTSxXQUFXLEdBQUcsSUFBQSxtQkFBUyxFQUFDLFFBQVEsQ0FBQyxDQUFDO0lBRXhDLElBQUEsaUJBQVMsRUFBQyxHQUFHLEVBQUU7UUFDYixNQUFNLFNBQVMsR0FBRyxVQUFVLENBQUMsR0FBRyxFQUFFO1lBQ2hDLFdBQVcsQ0FBQyxPQUFPLEVBQUUsQ0FBQztRQUN4QixDQUFDLEVBQUUsT0FBTyxDQUFDLENBQUM7UUFFWixPQUFPLEdBQUcsRUFBRTtZQUNWLGFBQWEsQ0FBQyxTQUFTLENBQUMsQ0FBQztRQUMzQixDQUFDLENBQUM7SUFDSixDQUFDLENBQUMsQ0FBQztBQUNMLENBQUM7QUFmRCw2QkFlQyJ9